import * as intl from 'react-intl-universal';
import { message } from 'antd';
import Http from 'common/utils/http';
import errors, { whiteList, errorsMsgList } from 'common/utils/http/errors';
import { list } from './retry';

const errorMsg = (code: any, message?: any) => errors[code]
    ? intl.get(errors[code]).d(errorsMsgList[code] || errors[code])
    : message || intl.get('Error.UnknownError');

// 处理错误码
const codeHandler = (code: any, data: any): any => {
    switch (code) {
    case 1000:
        return null;
    case 2800:
        return null;
    case 2513:
        return data.message && message.error(
            intl.get('Error.LinkGroupAssignRepeat', { field: data.message })
        );
    case 7300:
        return data.message && message.error(
            intl.get('Error.RebateRuleRepeat', { field: data.message.rule_serial })
        );
    case 7401:
        return data.message && message.error(
            intl.get('Error.RebateUserRepeat', { field: data.message.group_name })
        );
    case 6200:
        return data.message && message.error(
            intl.get('Error.BeingExported', { field: data.message.info })
        );
    default:
        return message.error(errorMsg(code, typeof data !== 'string' ? null : data));
    }
};

const http = Http({
    onError: ({ code, data }: any, url: string) => {
        if (code === 1006) {
            // 非对称密文解密失败后抛出 1006，自动刷新页面，获取最新密钥对
            codeHandler(code, data);
            setTimeout(() => window.location.reload(), 500);
            return;
        }
        if (!whiteList.includes(url)) {
            codeHandler(code, data);
            if (code === 2000 || code === 2800 || code === 2801 || code === 2802 || code === 2803) {
                setTimeout(() => window.location.reload(), 3000);
            }
        }
    },
    retry: {
        list,
        callback: (delay: number) => {
            message.error(intl.get('Hint.RetryRequest', { delay }).d(`Request Failed，${delay} 秒后自动重试`));
        }
    }
});

const get = http('get');
const post = http('post');
const upload = http('upload');

export { get, post, upload, errorMsg };
